import { AppNS } from 'app';
import { apiAddTicket } from 'app/api_v2/tickets';
import { hasPermission } from 'app/core/permissions';
import NewTicketForm from 'app/main/backoffice/tickets/components/new-ticket/new-ticket-form/NewTicketForm';
import CommonSuccessNotification from 'app/ui_v2/components/common-success-notification/CommonSuccessNotification';
import DataDialog from 'app/ui_v2/components/data-dialog/DataDialog';
import { getUserRoleInfo } from 'app/ui_v2/helpers/users';
import ViewIcon from 'app/ui_v2/icons/ViewIcon';
import { useState } from 'react';

import { Box, Button } from '@mui/material';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export interface TickedAddDirectProps {
  companyId: string;
  inspectorProfileId: string;
  inspectorId?: string;
  companyName: string;
  inspectorName: string;
}

export default function TickedAddDirect(props: TickedAddDirectProps) {
  const { companyId, inspectorProfileId, companyName, inspectorName, inspectorId = '' } = props;
  const { currentUser } = getUserRoleInfo();

  const [isOpened, setIsOpened] = useState(false);
  const [isSaved, setIsSaved] = useState(0);

  const queryKey = ['bo-tickets/get', ''];
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (data: Partial<AppNS.Ticket>) => apiAddTicket(data),
    onSuccess: (data: AppNS.Ticket) => {
      queryClient.removeQueries({
        queryKey,
      });
      // navigate(`../${data.id}`);
      setIsOpened(false);
      console.log('Ticket created:', data);
      setIsSaved((prev) => prev + 1);
    },
  });

  const handleFormSubmit = (values: Partial<AppNS.Ticket>) => {
    console.log('Form submitted:', values);
    mutation.mutate({ ...values, state: 'subject_action_required' });
  };

  const defaults: Partial<AppNS.Ticket> = {
    companyId: companyId,
    inspectorProfileId: inspectorProfileId,
    subject: companyId || inspectorProfileId,
    subjectType: companyId ? 'agency' : 'inspector',
    inspectorId,
    reviewerId: currentUser?.id || '',
    ticketType: 'compliance_manual_audit',
  };

  const metaData: AppNS.Params = {
    subjectName: companyName || inspectorName,
    isExternal: true,
  };

  const buttonText = companyId ? `Open ticket for Agency` : `Open ticket for Inspector`;

  if (!hasPermission(currentUser, 'tickets', 'create')) {
    return null;
  }

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        disableElevation
        onClick={() => {
          setIsOpened(true);
          setIsSaved(0);
        }}
      >
        <ViewIcon />
        <Box ml={1}>{buttonText}</Box>
      </Button>
      <DataDialog
        isDraggable={true}
        title="Create ticket"
        open={isOpened}
        isLoading={mutation.isLoading}
        handleCancelWithClosingIcon={() => {
          setIsOpened(false);
        }}
      >
        <>
          <NewTicketForm
            onFormSubmit={(v) => {
              console.log('onFormSubmit', v);
              handleFormSubmit(v as Partial<AppNS.Ticket>);
            }}
            isLoading={mutation.isLoading}
            onFormCancel={() => {
              setIsOpened(false);
            }}
            defaults={defaults}
            meta={metaData}
          />
        </>
      </DataDialog>
      <CommonSuccessNotification isOpened={isSaved} mainText="Ticket is successfully saved." severity="success" />
    </>
  );
}
